/**
 * 每日用户活跃统计走势图
 */

import { useState, useEffect } from 'react';
import { message } from 'antd';
import $ from 'jquery';
import { Chart } from '@antv/g2';
import { UjoinParams, AddRequestHeaders } from '../../incs/FunHelper.js';
import CNF from '../../incs/Config.js';

const UserUTACD = () => {
    const [messageApi, contextHolder] = message.useMessage();

    const [data, setData] = useState([]);

    const getData = () => {
        const params = {
            'time_interval': 180
        }
        $.ajax({
            url: `${CNF.sealApi}reports/user/utacd${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            crossDomain: true,
            type: 'GET',
            dataType: 'JSON', success: function (data) {
                if (data.res === 0) {
                    setData(data.dat);
                } else {
                    messageApi.error(data.msg, 1);
                }
            }
        })
    }

    useEffect(() => { getData(); }, []);
    useEffect(() => {
        const chart = new Chart({
            container: 'antv-g2-id-UserUTACD',
            autoFit: true,
        });


        chart.data(data);

        chart
            .line()
            .encode('x', 'date')
            .encode('y', 'count')
            .encode('color', 'type')
            .encode('shape', 'smooth')
            .scale('y', { independent: true })
            .scale('y', { nice: true })
            .scale('color', {
                range: CNF.swatches[CNF.currentSwatche],
            })
            .axis('x', { title: '日期', })
            .axis('y', { title: '', labelFormatter: (d) => (d) })
            .animate('enter', {
                type: 'pathIn',
                duration: CNF.animateDuration + 1000,
            },)
            .tooltip({
                items: [
                    (d) => {
                        if (d.type === '登录人数') {
                            return { channel: 'y', value: `${d.count}个`, }
                        } else {
                            return { channel: 'y', value: `${d.count}次`, }
                        }
                    },
                ],
            })
            .style('lineWidth', 1);
        chart.render();

        return () => {
            chart.destroy();
        }
    }, [data]);

    return <div id='antv-g2-id-UserUTACD'>{contextHolder}</div>;
}

export default UserUTACD;